module.exports = __webpack_public_path__ + "static/img/type3.b56bcd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type3.png
// module id = SljM
// module chunks = 1